import { useState, useEffect, useCallback } from 'react';

type VisibilityState = 'hidden' | 'visible' | 'closing';

interface UseAnimatedVisibilityOptions {
  isOpen: boolean;
  closeDuration?: number;
}

export function useAnimatedVisibility({
  isOpen,
  closeDuration = 300,
}: UseAnimatedVisibilityOptions) {
  const [state, setState] = useState<VisibilityState>(
    isOpen ? 'visible' : 'hidden'
  );

  useEffect(() => {
    if (isOpen) {
      setState('visible');
    } else if (state === 'visible') {
      setState('closing');
      const fallbackTimer = setTimeout(() => {
        setState('hidden');
      }, closeDuration + 50);
      return () => clearTimeout(fallbackTimer);
    }
  }, [isOpen]); // eslint-disable-line react-hooks/exhaustive-deps

  const onAnimationEnd = useCallback(() => {
    if (state === 'closing') {
      setState('hidden');
    }
  }, [state]);

  return {
    shouldRender: state !== 'hidden',
    isClosing: state === 'closing',
    onAnimationEnd,
  };
}
